<template>
  <div class="customHomeContainer">
    <div class="topProductsHeadline">
      {{
        getTranslation(
          $store,
          "CustomHomeSetting",
          "top_products_headline",
          customHomeSetting.id,
          customHomeSetting.top_products_headline
        )
      }}
    </div>
    <div class="topProducts">
      <product-list
        ref="topProducts"
        :products="this.topProducts"
        :maxHeight="225"
        @onAddBasket="emitOnAddBasket"
        @onConfirmProductAttributes="$emit('onConfirmProductAttributes')"
      />
    </div>
    <div class="promo animate">
      <product-attribute-icons-overlay
        :product="this.getPromoProduct"
        @onConfirmProductAttributes="onConfirmProductAttributesForPromo"
      />
      <img
        v-if="customHomeSetting.promo_image"
        :src="customHomeSetting.promo_image"
        @click="addPromoToBasket"
      />
      <video
        v-else
        loop
        class="promoVideo"
        autoplay
        muted
        preload
        :src="customHomeSetting.promo_video"
        @click="addPromoToBasket"
        playsinline
      ></video>
    </div>
    <div class="bottomProductsHeadline">
      {{
        getTranslation(
          $store,
          "CustomHomeSetting",
          "bottom_products_headline",
          customHomeSetting.id,
          customHomeSetting.bottom_products_headline
        )
      }}
    </div>
    <div class="bottomProducts">
      <product-list
        ref="bottomProducts"
        :products="this.bottomProducts"
        :maxHeight="225"
        @onAddBasket="emitOnAddBasket"
        @onConfirmProductAttributes="$emit('onConfirmProductAttributes')"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getTranslation } from "../../utils/helpers";
import { checkSchedules } from "@/utils/schedules";
import ProductList from "@/components/menu/ProductList.vue";
import ProductAttributeIconsOverlay from "@/components/common/ProductAttributeIconsOverlay.vue";

export default {
  name: "CustomHome",
  components: { ProductAttributeIconsOverlay, ProductList },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      customHomeSetting: "CUSTOM_HOME_SETTING",
      productsFiltered: "PRODUCTS_FILTERED",
      deliveryMethod: "SELECTED_DELIVERY_METHOD",
      schedules: "SCHEDULES"
    }),
    getPromoProduct() {
      if (!this.customHomeSetting.promo_product) return {};
      let promo_items = this.filterProductsByIds([
        this.customHomeSetting.promo_product
      ]);
      if (promo_items.length > 0) {
        console.log("promo_items[0] " + JSON.stringify(promo_items[0]));
        return promo_items[0];
      } else {
        return {};
      }
    },
    topProducts() {
      if (!this.customHomeSetting.top_products) return [];
      return this.filterProductsByIds(this.customHomeSetting.top_products);
    },
    bottomProducts() {
      if (!this.customHomeSetting.bottom_products) return [];
      return this.filterProductsByIds(this.customHomeSetting.bottom_products);
    }
  },
  methods: {
    init() {
      console.log("init");
    },
    getTranslation,
    filterProductsByIds(ids) {
      if (!ids) return [];
      return this.productsFiltered.reduce((acc, item) => {
        if (!ids.includes(item.id)) return acc;
        if (item.hide) return acc;
        let soldOut =
          item.soldout ||
          item.default_ingredients.some(
            ing => ing.default_count >= 1 && (ing.soldout || ing.hide)
          );
        let newItem = { ...item, soldout: soldOut };
        return checkSchedules(this.schedules, newItem) &&
          (item.delivery_methods.length === 0 ||
            item.delivery_methods.includes(this.delivery_method))
          ? [...acc, newItem]
          : acc;
      }, []);
    },
    emitOnAddBasket(item) {
      this.$emit("onAddBasket", item);
    },
    addPromoToBasket() {
      if (this.getPromoProduct) {
        this.$emit("onGoPromo", this.getPromoProduct);
      }
    },
    onConfirmProductAttributesForPromo(p) {
      this.$emit("onConfirmProductAttributes");
      this.$emit("onGoPromo", p);
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes promoBoxIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.customHomeContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.promo {
  img,
  video {
    border-radius: var(--component_menu_CustomHome_promo_border-radius);
    width: 100%;
    aspect-ratio: 2;
    object-fit: cover;
  }
}

.promo.animate {
  animation: promoBoxIn 500ms forwards ease;
}

.topProductsHeadline {
  color: var(--component_menu_CustomHome_topProductsHeadline_color);
  font-family: var(--component_menu_CustomHome_topProductsHeadline_font-family);
  font-size: var(--component_menu_CustomHome_topProductsHeadline_font-size);
  padding: 0;
}

.bottomProductsHeadline {
  color: var(--component_menu_CustomHome_bottomProductsHeadline_color);
  font-family: var(
    --component_menu_CustomHome_bottomProductsHeadline_font-family
  );
  font-size: var(--component_menu_CustomHome_bottomProductsHeadline_font-size);
  padding: 0;
}
</style>
